/**
 * Screen related helper functions.
 */
const MXM = 100
const MXMS = 75
const MXMF = 50
const MXMT = 25

export const ScreenUtils = {

    /**
     * calculate the percentage of initial page load
     *
     * @return % of page loaded
     */

    initPageYcord(): number {
        return Math.round(
            (window.innerHeight + window.scrollY) / (document.body.scrollHeight) * MXM
        )
    },

    /**
     * calculate page load percentage
     * taken from existing implementation
     * @TODO - improve logic
     *
     * @return % of page load
     */

    crntPageYcord(): number {
        const initialPercentage = this.initPageYcord()
        let percentageOfPageViewed = 0
        if (initialPercentage > percentageOfPageViewed) {
            if (initialPercentage >= MXM) {
                percentageOfPageViewed = MXM
            } else if (initialPercentage >= MXMS) {
                percentageOfPageViewed = MXMS
            } else if (initialPercentage >= MXMF) {
                percentageOfPageViewed = MXMF
            } else if (initialPercentage >= MXMT) {
                percentageOfPageViewed = MXMT
            }
        }
        return percentageOfPageViewed
    },

    /**
     * checks if a html element in view
     */
    inView(el: Element): boolean {
        const scroll = window.scrollY || window.pageYOffset
        const boundsTop = el.getBoundingClientRect().top + scroll

        const viewPort = {
            bottom: scroll + window.innerHeight,
            top: scroll
        }

        const bounds = {
            bottom: boundsTop + el.clientHeight,
            top: boundsTop
        }
        return (bounds.bottom >= viewPort.top && bounds.bottom <= viewPort.bottom)
            || (bounds.top <= viewPort.bottom && bounds.top >= viewPort.top)
    }
}
